module.exports = __webpack_public_path__ + "yeni elit vizyon mutfak 1.jpg?6bf5690c7c2caa47ffb1dd084be3128d";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni elit vizyon mutfak 1.jpg
// module id = 375
// module chunks = 0